import { gql } from 'graphql-request';

const Logo = gql`
  fragment Logo on ImageObjectType {
    md: rendition(height: 150) {
      url
    }
    sm: rendition(height: 75) {
      url
    }
    title
  }
`;
export default Logo;
